import React from 'react';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import SwatchRequestFormOld from './SwatchRequestFormOld';
import SwatchRequestFormNew from './SwatchRequestFormNew';

const SwatchRequestForm = props => {
  const postHogFlag = usePostHogFeatureFlag('SwatchRequestAVS');

  return (
    <div>
      {postHogFlag === 'test' ? (
        <SwatchRequestFormNew {...props} />
      ) : (
        <SwatchRequestFormOld {...props} />
      )}
    </div>
  );
};

export default SwatchRequestForm;
